module.exports = __webpack_public_path__ + "img/_logo.d580eac5.png";